export default [
  {
    name: 'getOrgList',
    method: 'POST',
    path: '/OP/TenantInfo/GetOrgList',
    params: {
      Sort: 'CODE',
      Order: 0,
      Parameter10: window.location.host,
      Parameter11: '0'
    },
    axiosOptions: {
      noAttachedData: true
    },
    desc: '获取组织'
  },
  {
    name: 'login',
    method: 'POST',
    path: '/ENT/Login/PlatLogin',
    params: {
      OrgId: '',
      UserName: '',
      Password: '',
      GrantType: 0,
      Random: '',
      VerificationCode: ''
    },
    axiosOptions: {
      noAttachedData: true,
      fullData: true
    },
    desc: '登录接口'
  },
  {
    name: 'getUser',
    method: 'GET',
    path: '/ENT/Login/GetUser',
    params: {},
    axiosOptions: {
      noAttachedData: true,
      noErrorToast: true,
    },
    desc: '获取用户信息'
  },
  {
    name: 'getPerm',
    method: 'GET',
    path: '/ENT/Login/GetPerm',
    params: {},
    axiosOptions: {
      noAttachedData: true,
      noErrorToast: true,
    },
    desc: '获取用户权限'
  },
  {
    name: 'getMenuInfo',
    method: 'GET',
    path: '/ENT/Menu/GetMenuInfo',
    params: {},
    axiosOptions: {
      noAttachedData: true,
      noErrorToast: true,
    },
    desc: '获取应用菜单'
  },
  {
    name: 'getPictures',
    method: 'POST',
    path: '/OP/Picture/OrderEntities',
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取图片资源'
  },
  {
    name: 'getVerifyCode',
    method: 'GET',
    path: '/Common/VerifyPhone/MobileUserVerifyCode',
    params: {
      phone: ''
    },
    axiosOptions: {},
    desc: '获取短信验证码'
  },
  {
    name: 'checkVerifyCode',
    method: 'POST',
    path: '/OP/Login/PreLoginByPhone',
    params: {
      OrgId: '',
      Phone: '',
      SMSCode: ''
    },
    axiosOptions: {},
    desc: '手机验证码校验'
  }
]